import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  homepageSelector,
  homepageEditSelector,
  homepageSavingSelector,
  homepageLoadingSelector,
  editHomepage,
  cancelEditHomepage,
  updateHomepage,
  saveHomepage,
  uploadHomepageImage,
  homepageImageSavingSelector,
} from '../../../reducers';

import ManageHomepage from './component';

const mapStateToProps = (state) => {
  return {
    homepage: homepageSelector(state),
    homepageEdit: homepageEditSelector(state),
    saving: homepageSavingSelector(state) ? true : false,
    loading: homepageLoadingSelector(state) ? true : false,
    uploadingImage: homepageImageSavingSelector(state) ? true : false,
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    editHomepage,
    cancelEditHomepage,
    updateHomepage,
    saveHomepage,
    uploadHomepageImage,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageHomepage);



// WEBPACK FOOTER //
// ./src/component/organisms/ManageHomepage/index.js